import { thunkProgress } from 'redux-progress';

import type { Dispatch, GetState } from 'model/State';
import { UPDATE_CC_DETAILS } from './types';
import { updateCCDetails } from '../../api/creditCard';
import { MACCreditCardDetails } from 'modules/mac/duck/api/storage';

export const postUpdateCCDetails = (id: number) => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  const creditCardData = MACCreditCardDetails().load();

  const updateCCDetailsData = updateCCDetails(id, creditCardData, state);
  dispatch(thunkProgress(UPDATE_CC_DETAILS, updateCCDetailsData, { id }));
};
